import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

declare var $: any;

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit, AfterViewInit, OnDestroy {

  private domUpdateTimeout: any;

  imageUrl!: string;
  contentTitle = 'About Us - Xipe Tech';
  contentDescription = 'Xipe Tech is a Technological solutions company providing the best kind of IT services for your business with utmost professionalism';
  contentKeywords = 'Technology Software, Web Development, API integration, PHP Development, Next.js development, React.js development, Node.js development, CMS Development, MVC Development, Android Application, iPhone Application, UI/UX Designing, UI Designing, 3D Designing, Logo Designing, Cloud computing, Artificial intelligence, Data analytics, Cybersecurity, Web development, Mobile app development, IT consulting, Virtual reality, Augmented reality, Web design Website development, Front-end development, Back-end development, Full-stack development, Responsive design, User interface (UI), User experience (UX), Custom web development, E-commerce development, Laravel development, Yii development, Codeigniter development, Content management systems (CMS), WordPress development, Drupal development, Magento development, Shopify development, Mobile-friendly websites, Cross-browser compatibility, Web application development, API integration, Website maintenance';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page meta data
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: 'png'
    });
  }

  ngAfterViewInit(): void {
    this.domUpdateTimeout = setTimeout(() => {
      this.applyDomManipulations();
    }, 0);
  }

  private applyDomManipulations(): void {
    $.fn.shapeMockup = function () {
      var $shape = $(this);
      $shape.each(function () {
        var $currentShape = $(this),
          shapeTop = $currentShape.data("top"),
          shapeRight = $currentShape.data("right"),
          shapeBottom = $currentShape.data("bottom"),
          shapeLeft = $currentShape.data("left");
        $currentShape
          .css({
            top: shapeTop,
            right: shapeRight,
            bottom: shapeBottom,
            left: shapeLeft,
          })
          .removeAttr("data-top")
          .removeAttr("data-right")
          .removeAttr("data-bottom")
          .removeAttr("data-left")
          .parent()
          .addClass("shape-mockup-wrap");
      });
    };

    if ($(".shape-mockup")) {
      $(".shape-mockup").shapeMockup();
    }
  }

  ngOnDestroy(): void {
    if (this.domUpdateTimeout) {
      clearTimeout(this.domUpdateTimeout);
    }
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/noimage.png';
  }
}
